import { render, staticRenderFns } from "./TheModalEdad.vue?vue&type=template&id=b54414d0&scoped=true&"
import script from "./TheModalEdad.vue?vue&type=script&lang=js&"
export * from "./TheModalEdad.vue?vue&type=script&lang=js&"
import style0 from "./TheModalEdad.vue?vue&type=style&index=0&id=b54414d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54414d0",
  null
  
)

export default component.exports